//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: String,
    size: {
      type: String,
      default: 'sm',
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    unclosable: {
      type: Boolean,
      default: false,
    },
    noHeader: {
      type: Boolean,
      default: false,
    },
    noFooter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    rootCssClass() {
      return {
        'corems-shared-modal': 'corems-shared-modal',
        'corems-shared-modal--no-header': this.noHeader,
      };
    },
    cardCssClass() {
      return `corems-shared-modal__card--${this.size}`;
    },
  },
  methods: {
    show() {
      this.isOpen = true;
    },
    hide() {
      this.isOpen = false;
    },
  },
};
